import { Button } from '@mantine/core';
import { IconLock, IconMapPinOff } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { EmptyState } from './EmptyState';

/** 403 state used by `<RequirePermission>`. */
export function ForbiddenState() {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={IconLock}
      title={t('common:errors.forbiddenTitle')}
      description={t('common:errors.forbiddenText')}
      action={
        <Button component={Link} to="/" variant="light">
          {t('common:nav.backHome')}
        </Button>
      }
    />
  );
}

/** 404 state for unknown routes. */
export function NotFoundState() {
  const { t } = useTranslation();
  return (
    <EmptyState
      icon={IconMapPinOff}
      title={t('common:errors.notFoundTitle')}
      description={t('common:errors.notFoundText')}
      action={
        <Button component={Link} to="/" variant="light">
          {t('common:nav.backHome')}
        </Button>
      }
    />
  );
}
